define([
    './defined',
    './defaultValue'
    ], function(
        defined,
        defaultValue
    ) {
    'use strict'

    /**
     * 将Number对象数组转成一定规则的字符串，用于参数传递。
     *
     * @private
     *
     * @exports numberArray2String
     */
    const numberArray2String = (arr, sp1)=>{
        let splitStr1 = defaultValue(sp1, ";")
        let result = ""
        for (let i = 0; i < arr.length; ++i) {
            result += arr[i] + splitStr1
        }
        return result
    };
    return numberArray2String
});
